"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AGENT_IMAGE_MODEL_OPTIONS = exports.DEFAULT_IMAGE_MODEL_FLAG_VARIANTS = exports.EDIT_ONLY_IMAGE_MODELS = exports.AGENT_SELECTABLE_IMAGE_MODELS = exports.DEFAULT_IMAGE_MODEL = exports.OPENAI_IMAGE_MODELS = exports.ModelType = void 0;
exports.isOpenAiImageModel = isOpenAiImageModel;
exports.resolveDefaultImageModelFlagValue = resolveDefaultImageModelFlagValue;
exports.normalizeModelTypeAlias = normalizeModelTypeAlias;
exports.resolveAgentImageModel = resolveAgentImageModel;
exports.isEditOnlyImageModel = isEditOnlyImageModel;
exports.resolveAgentCreationImageModel = resolveAgentCreationImageModel;
exports.isAgentImageModelPinned = isAgentImageModelPinned;
exports.getImageModelLabel = getImageModelLabel;
var ModelType;
(function (ModelType) {
    // Sora
    ModelType["SORA_2"] = "sora-2-2025-12-08";
    ModelType["SORA_2_PRO"] = "sora-2-pro";
    // Gemini Nano Banana
    ModelType["NANO_BANANA_2_1"] = "gemini-nano-banana-2.1";
    ModelType["NANO_BANANA_2"] = "gemini-3.1-flash-image";
    ModelType["NANO_BANANA_PRO"] = "gemini-3-pro-image";
    ModelType["NANO_BANANA"] = "gemini-2.5-flash-image";
    // Fal AI Nano Banana
    ModelType["FAL_NANO_BANANA_PRO"] = "fal-ai/nano-banana-pro";
    ModelType["FAL_NANO_BANANA_PRO_EDIT"] = "fal-ai/nano-banana-pro/edit";
    ModelType["FAL_NANO_BANANA"] = "fal-ai/nano-banana";
    ModelType["FAL_NANO_BANANA_EDIT"] = "fal-ai/nano-banana/edit";
    ModelType["FAL_NANO_BANANA_2"] = "fal-ai/nano-banana-2";
    ModelType["FAL_NANO_BANANA_2_EDIT"] = "fal-ai/nano-banana-2/edit";
    // fal serves Nano Banana 2.1 under Google's namespace, not `fal-ai/`.
    ModelType["FAL_NANO_BANANA_2_1"] = "google/nano-banana-2.1";
    ModelType["FAL_NANO_BANANA_2_1_EDIT"] = "google/nano-banana-2.1/edit";
    // Gemini
    ModelType["GEMINI_3_1_PRO"] = "gemini-3.1-pro-preview";
    ModelType["GEMINI_3_FLASH"] = "gemini-3-flash-preview";
    ModelType["GEMINI_3_6_FLASH"] = "gemini-3.6-flash";
    ModelType["GEMINI_3_1_FLASH_LITE"] = "gemini-3.1-flash-lite-preview";
    ModelType["GEMINI_3_5_FLASH_LITE"] = "gemini-3.5-flash-lite";
    // VEO
    ModelType["VEO_3_0"] = "veo-3.0-generate-001";
    ModelType["VEO_3_1"] = "veo-3.1-generate-001";
    ModelType["VEO_3_1_FAST"] = "veo-3.1-fast-generate-001";
    // Fal AI Seedance
    ModelType["FAL_SEEDANCE_2_TEXT_TO_VIDEO"] = "bytedance/seedance-2.0/text-to-video";
    ModelType["FAL_SEEDANCE_2_REFERENCE_TO_VIDEO"] = "bytedance/seedance-2.0/reference-to-video";
    /** BytePlus ModelArk — Seedance 2.0 large (dreamina) */
    ModelType["BYTEPLUS_SEEDANCE_2"] = "dreamina-seedance-2-0-260128";
    /** BytePlus ModelArk — Seedance 2.5. Production use is gated until the account canary passes. */
    ModelType["BYTEPLUS_SEEDANCE_2_5"] = "dreamina-seedance-2-5-260628";
    // Wavespeed AI
    ModelType["WAVESPEED_AI_INFINITETALK"] = "wavespeed-ai/infinitetalk";
    ModelType["WAVESPEED_AI_INFINITETALK_MULTI_VOICE"] = "wavespeed-ai/infinitetalk/multi";
    // GPT 5.2
    ModelType["GPT_5_2"] = "gpt-5.2";
    // GPT 5.4
    ModelType["GPT_5_4"] = "gpt-5.4";
    ModelType["GPT_LATEST"] = "gpt-5.5";
    ModelType["GPT_5_4_MINI"] = "gpt-5.4-mini";
    ModelType["GPT_5_6_LUNA"] = "gpt-5.6-luna";
    // OpenAI Image — values are the exact Images API model ids.
    ModelType["GPT_IMAGE_2"] = "gpt-image-2";
    ModelType["GPT_IMAGE_2_5_FLARE"] = "gpt-image-2.5-flare";
    ModelType["GPT_IMAGE_2_5_SUNBURST"] = "gpt-image-2.5-sunburst";
    // Ideogram — value is the precise-edit endpoint's model path segment.
    ModelType["IDEOGRAM_4_5"] = "ideogram-4-5";
    // Vertex
    // Vertex Claude
    ModelType["ANTHROPIC_CLAUDE_5_FABLE"] = "anthropic-claude-5-fable";
    ModelType["ANTHROPIC_CLAUDE_5_OPUS"] = "anthropic-claude-5-opus";
    ModelType["ANTHROPIC_CLAUDE_4_8_OPUS"] = "anthropic-claude-4-8-opus";
    ModelType["ANTHROPIC_CLAUDE_4_6_OPUS"] = "anthropic-claude-4-6-opus";
    ModelType["ANTHROPIC_CLAUDE_5_SONNET"] = "anthropic-claude-5-sonnet";
    ModelType["ANTHROPIC_CLAUDE_4_6_SONNET"] = "anthropic-claude-4-6-sonnet";
    ModelType["ANTHROPIC_CLAUDE_4_5_HAIKU"] = "anthropic-claude-4-5-haiku";
    ModelType["VERTEX_ANTHROPIC_CLAUDE_5_FABLE"] = "vertex-anthropic-claude-5-fable";
    ModelType["VERTEX_ANTHROPIC_CLAUDE_5_OPUS"] = "vertex-anthropic-claude-5-opus";
    ModelType["VERTEX_ANTHROPIC_CLAUDE_4_8_OPUS"] = "vertex-anthropic-claude-4-8-opus";
    ModelType["VERTEX_ANTHROPIC_CLAUDE_4_6_OPUS"] = "vertex-anthropic-claude-4-6-opus";
    ModelType["VERTEX_ANTHROPIC_CLAUDE_4_6_SONNET"] = "vertex-anthropic-claude-4-6-sonnet";
    ModelType["VERTEX_ANTHROPIC_CLAUDE_5_SONNET"] = "vertex-anthropic-claude-5-sonnet";
    ModelType["VERTEX_ANTHROPIC_CLAUDE_4_5_HAIKU"] = "vertex-anthropic-claude-4-5-haiku";
    // OpenRouter — value is the exact OpenRouter model slug, so it doubles as the
    // registry key AND matches the provider-reported `response.modelId` for pricing.
    ModelType["OPEN_ROUTER_GLM_5_2"] = "z-ai/glm-5.2";
    // Dedicated Modal deployment — exact case-sensitive endpoint model id.
    ModelType["MODAL_KIMI_K3"] = "moonshotai/Kimi-K3";
})(ModelType || (exports.ModelType = ModelType = {}));
/** Every OpenAI image model the platform can call. */
exports.OPENAI_IMAGE_MODELS = [
    ModelType.GPT_IMAGE_2,
    ModelType.GPT_IMAGE_2_5_FLARE,
    ModelType.GPT_IMAGE_2_5_SUNBURST,
];
/** Whether a persisted or requested model id names an OpenAI image model (after alias normalization). */
function isOpenAiImageModel(value) {
    if (!value)
        return false;
    const normalized = normalizeModelTypeAlias(value);
    return exports.OPENAI_IMAGE_MODELS.includes(normalized);
}
/**
 * Platform default image model: renders agents with no (or an unknown) model, backs the `default-image-model`
 * flag when it assigns nothing, and creates new creatives for edit-only selections.
 */
exports.DEFAULT_IMAGE_MODEL = ModelType.GPT_IMAGE_2_5_SUNBURST;
/** Image models a user may pick for an agent. Order is the selector's display order. */
exports.AGENT_SELECTABLE_IMAGE_MODELS = [
    ModelType.GPT_IMAGE_2_5_SUNBURST,
    ModelType.GPT_IMAGE_2_5_FLARE,
    ModelType.NANO_BANANA_2_1,
    ModelType.NANO_BANANA_2,
    ModelType.GPT_IMAGE_2,
    ModelType.IDEOGRAM_4_5,
];
/** Selectable image models that can only edit an existing image, never create one from scratch. */
exports.EDIT_ONLY_IMAGE_MODELS = [ModelType.IDEOGRAM_4_5];
/**
 * Variants of the `default-image-model` PostHog flag, each naming the image model a user's new chats start on.
 * Keys are hyphen-only because PostHog restricts the characters of a variant key.
 */
exports.DEFAULT_IMAGE_MODEL_FLAG_VARIANTS = {
    'gpt-image-2-5-sunburst': ModelType.GPT_IMAGE_2_5_SUNBURST,
    'nano-banana-2-1': ModelType.NANO_BANANA_2_1,
};
/** The image model a `default-image-model` flag value assigns; the platform default for any other value. */
function resolveDefaultImageModelFlagValue(value) {
    const variant = Object.entries(exports.DEFAULT_IMAGE_MODEL_FLAG_VARIANTS).find(([key]) => key === value);
    return variant?.[1] ?? exports.DEFAULT_IMAGE_MODEL;
}
const MODEL_TYPE_ALIASES = {
    'gemini-3.1-flash-image-preview': ModelType.NANO_BANANA_2,
    'gemini-3-pro-image-preview': ModelType.NANO_BANANA_PRO,
    'gemini-2.5-flash-image-preview': ModelType.NANO_BANANA,
    'gpt-image-2-2026-04-21': ModelType.GPT_IMAGE_2,
    'gpt-image-2.5-flare-2026-09-08': ModelType.GPT_IMAGE_2_5_FLARE,
    'gpt-image-2.5-sunburst-2026-09-08': ModelType.GPT_IMAGE_2_5_SUNBURST,
};
/** Translates renamed provider model identifiers to their current canonical values. */
function normalizeModelTypeAlias(value) {
    return MODEL_TYPE_ALIASES[value] ?? value;
}
/** Resolves persisted agent data to a currently selectable image model. */
function resolveAgentImageModel(value) {
    const normalized = value ? normalizeModelTypeAlias(value) : value;
    return exports.AGENT_SELECTABLE_IMAGE_MODELS.find((model) => model === normalized) ?? exports.DEFAULT_IMAGE_MODEL;
}
/** Whether a persisted or requested model id names an edit-only image model (after alias normalization). */
function isEditOnlyImageModel(value) {
    if (!value)
        return false;
    const normalized = normalizeModelTypeAlias(value);
    return exports.EDIT_ONLY_IMAGE_MODELS.includes(normalized);
}
/**
 * Resolves the image model that renders an agent's NEW creatives: its selection, or the platform default when the
 * selection is edit-only and therefore cannot create from scratch.
 */
function resolveAgentCreationImageModel(value) {
    const resolved = resolveAgentImageModel(value);
    return isEditOnlyImageModel(resolved) ? exports.DEFAULT_IMAGE_MODEL : resolved;
}
/**
 * Whether an agent's image model was picked by the user rather than being their default. Rows from before picks
 * were recorded (`imageModelPinned` null) count as picked unless their model is empty or GPT Image 2.5 Sunburst,
 * the default the composer stored for them.
 */
function isAgentImageModelPinned(agent) {
    if (agent.imageModelPinned !== null)
        return agent.imageModelPinned;
    return agent.imageModel !== null && resolveAgentImageModel(agent.imageModel) !== ModelType.GPT_IMAGE_2_5_SUNBURST;
}
/** Interactive "Statics / image model" rows rendered in the agent image-model selector. */
exports.AGENT_IMAGE_MODEL_OPTIONS = [
    {
        id: ModelType.GPT_IMAGE_2_5_SUNBURST,
        label: 'GPT Image 2.5 Sunburst',
        description: 'OpenAI’s most capable image model. Best for new creatives, slower.',
    },
    {
        id: ModelType.GPT_IMAGE_2_5_FLARE,
        label: 'GPT Image 2.5 Flare',
        description: 'OpenAI image model. Faster than Sunburst, better than GPT Image 2.',
    },
    {
        id: ModelType.NANO_BANANA_2_1,
        label: 'Nano Banana 2.1',
        description: 'Newest Google Gemini image model. Faster and better than Nano Banana 2.',
    },
    {
        id: ModelType.NANO_BANANA_2,
        label: 'Nano Banana 2',
        description: 'Previous Google Gemini image model.',
    },
    {
        id: ModelType.GPT_IMAGE_2,
        label: 'GPT Image 2',
        description: 'Previous OpenAI image model.',
    },
    {
        id: ModelType.IDEOGRAM_4_5,
        label: 'Ideogram 4.5',
        description: 'Precise edits of existing creatives that leave the rest untouched. New creatives and uploaded images use GPT Image 2.5 Sunburst.',
        editOnly: true,
    },
];
/** Display label for a selectable image model, falling back to the raw id for anything unknown. */
function getImageModelLabel(model) {
    const resolved = resolveAgentImageModel(model);
    return exports.AGENT_IMAGE_MODEL_OPTIONS.find((option) => option.id === resolved)?.label ?? resolved;
}
